import React, { useEffect } from 'react';
import { withFormik } from 'formik';
import { Row, Col } from 'antd';
import FormInput from '../../../../../components/Forms/Input';
import DatePickerField from '../../../../../components/DatePicker';
import { FormProps, IFilterCancellationProps, IFilterCancellationValues } from './types';
import {
  DateView,
  Button,
  ResetButton,
  Form,
  Label,
} from './styles';
import SelectField from '../../../../../components/Select';
import { ISelectValue } from '../../../../../global/types';

const options: ISelectValue[] = [
  { label: 'Solicitada', value: 'Solicitada' },
  { label: 'Em análise', value: 'Em análise' },
  { label: 'Concluída', value: 'Concluída' },
  { label: 'Rejeitada', value: 'Rejeitada' },
]

const FilterForm: React.FC<FormProps> = (props: FormProps) => {
  const {
    handleSubmit,
    onFormSubmit,
    resetForm,
    values,
    setFieldValue,
  } = props;

  const resetFormTransaction = async () => {
    resetForm();
    await onFormSubmit({} as IFilterCancellationValues);
  };

  useEffect(() => {
    const numeroDocumento = values.numeroDocumento?.replace(/[^0-9]/g, '');
    const nsuParcela = values.nsuParcela?.replace(/[^0-9]/g, '');
    setFieldValue('numeroDocumento', numeroDocumento);
    setFieldValue('nsuParcela', nsuParcela);

    const handleSetMaskedInput = () => {
      if (numeroDocumento.length === 14) {
        const cnpj = numeroDocumento.match(/^([0-9]{2})([0-9]{3})([0-9]{3})([0-9]{4})([0-9]{2})/);
        if (cnpj !== null) {
          const cnpjFormatted = `${cnpj[1]}.${cnpj[2]}.${cnpj[3]}/${cnpj[4]}-${cnpj[5]}`;
          setFieldValue('numeroDocumento', cnpjFormatted);
        }
      }

      if (nsuParcela.length === 14) {
        const nsu = nsuParcela.match(/^([0-9]{12})([0-9]{1})([0-9]{1})/);
        if (nsu !== null) {
          const nsuFormatted = `${nsu[1]}-${nsu[2]}/${nsu[3]}`;
          setFieldValue('nsuParcela', nsuFormatted);
        }
      }
    }

    handleSetMaskedInput();
  }, [values.numeroDocumento, values.nsuParcela]);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row>
          <Label>Filtros:</Label>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <FormInput
              type="text"
              name="razaoSocial"
              label="Empresa"
            />
          </Col>
          <Col span={6}>
            <FormInput
              type="text"
              name="numeroDocumento"
              label="CNPJ"
            />
          </Col>
          <Col span={6}>
            <DateView>
              <DatePickerField
                name="dataTransacaoInicio"
                placeholder=""
                label="Data transação início"
              />
            </DateView>
          </Col>
          <Col span={6}>
            <DateView>
              <DatePickerField
                name="dataTransacaoFim"
                placeholder=""
                label="Data transação fim"
              />
            </DateView>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <FormInput
              type="text"
              name="nsuParcela"
              label="NSU/Parcela"
            />
          </Col>
          <Col span={6}>
            <SelectField
              name="statusCancelamento"
              placeholder=""
              label="Status cancelamento"
              options={options}
            />
          </Col>
          <Col span={6}>
            <DateView>
              <DatePickerField
                name="dataCancelamentoInicio"
                placeholder=""
                label="Data cancelamento início"
              />
            </DateView>
          </Col>
          <Col span={6}>
            <DateView>
              <DatePickerField
                name="dataCancelamentoFim"
                placeholder=""
                label="Data cancelamento fim"
              />
            </DateView>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6} />
          <Col span={6} />
          <Col span={6} />
          <Col span={3}>
            <ResetButton onClick={() => resetFormTransaction()}>
              Limpar filtros
            </ResetButton>
          </Col>
          <Col span={3}>
            <Button htmlType="submit">
              Aplicar filtros
            </Button>
          </Col>
        </Row>
      </Form>
    </>
  )
}
export default withFormik<IFilterCancellationProps, IFilterCancellationValues>({
  mapPropsToValues: (): IFilterCancellationValues => ({
    numeroDocumento: '',
    razaoSocial: '',
    dataTransacaoInicio: '',
    dataTransacaoFim: '',
    nsuParcela: '',
    dataCancelamentoInicio: '',
    dataCancelamentoFim: '',
    statusCancelamento: null,
  }),
  handleSubmit: async (values, { props }) => {
    const numeroDocumento = values.numeroDocumento.replace(/[^0-9]/g, '');
    const nsuParcela = values.nsuParcela.replace(/[^0-9]/g, '');

    await props.onFormSubmit({
      ...values,
      numeroDocumento,
      nsuParcela,
    });
  },
})(FilterForm);
